
import React from 'react';
import api from './api';
import CustomDataTable from './CustomDataTable';
import './Doctors.css';
import { FaEdit, FaTrash } from "react-icons/fa";

//import MDButton from './MDButton';

//import "./styles.css";

import {
    useState,
    useEffect
} from 'react';

const Orgs = () => {
  const [orgs, setOrgs] = useState([]);
  const [newOrg, setNewOrg] =   useState({status: "active"});
  const [selectedOrg, setSelectedOrg] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  
    useEffect(() => {
        console.log("getting branches and orgs");
        
        getOrgs();
      }, []);

 
const ocolumns = [
  {
    name: "Name",
    selector: (row) => row && row.name,
    sortable: true,
  },
  {
    name: "Acronym",
    selector: (row) => row && row.acr,
    sortable: true,
  },
  {
    name: "Status",
    selector: (row) => row && row.status,
    sortable: true,
  },
  {
    name: "Address",
    selector: (row) => row && row.address,
    sortable: true,
  },
  {
    name: "GSTIN",
    selector: (row) => row && row.gstin,
    sortable: false,
  },
  {
    name: "UPI-ID",
    selector: (row) => row && row.upid,
    sortable: false,
  },
  {
    name: "Phone 1",
    selector: (row) => row && row.phone1,
    sortable: true,
  },
  {
    name: "Email 1",
    selector: (row) => row && row.email1,
    sortable: true,
  },
  /*
  {
    name: "Phone 2",
    selector: (row) => row && row.phone2,
    sortable: true,
  },
  {
    name: "Email 2",
    selector: (row) => row && row.email2,
    sortable: true,
  },*/
  {
    name: "Actions",
    sortable: false,
    cell: (row) => (
        <>
     <div style={{ display: 'flex', gap: '30px', alignItems: 'center' }}>
      <div className="task-icon">
        <FaEdit 
            onClick={() => handleEditOrg(row && row._id)} 
            style={{ cursor: 'pointer', color: 'green' }}
        />
        </div>
        <div className="task-icon"> 
        <FaTrash 
            onClick={() => handleDeleteOrg(row && row._id)} 
            style={{ cursor: 'pointer', color: 'red' }}
        />
        </div>
        </div>
     </>
    ),
  },
];

const otableData = {
  columns: ocolumns,
  data: orgs,
};

    // A super simple expandable component.
    const getOrgs = async () => {
        try {
            const response = await api.get(`${process.env.REACT_APP_URL}/orgs`);
            console.log("from mongo fetch", response.data);
            setOrgs(response.data);
        } catch (error) {
            console.error("Error fetching Orgs:", error);
        }
        };

  
    const handleAdd =
        (e) => {
            e.preventDefault();    
          
                if (!validateOrgFields(newOrg)) return;
  
                api.post(
                    `${process.env.REACT_APP_URL}/orgs/add`, newOrg)
                    .then(response => {
                      alert("Org added Successfully!");
                    
                      handleClose();
                    })
                    .catch(error =>
                        console.error('Error adding Org:', error));
            
    }

    const handleUpdate = (e) => {
            e.preventDefault();
          
              if (!validateOrgFields(selectedOrg)) return;

  
                    api.post(
                    `${process.env.REACT_APP_URL}/orgs/update/${selectedOrg._id}`, selectedOrg)
                        .then(response => {
                         alert("Org updated Successfully!");
                        handleClose();
                    })
                    .catch(
                        error =>
                            alert('Error updating org:', error));
                    
        };

      const handleDeleteOrg =
      (id) => {  
          const ret = window.confirm("Are you sure you want to delete this Entry ?");
    if (!ret )
      return;
                 api.delete(
                        `${process.env.REACT_APP_URL}/orgs/delete/${id}`)
                        .then(response => {
                                
                                alert ("Org deleted successfully.");
                                handleClose();
                            })
              .catch(
                  error =>
                      alert('Error deleting Org'));
      };

const validateOrgFields = (org) => {
  let requiredFields = ['name', 'acr', 'address', 'status', 'phone1'];
  if (isEditMode === true) {
    requiredFields = [];
  }

  for (const field of requiredFields) {
    if (!org[field]) {
      alert(`Please fill in the ${field.toUpperCase()} field.`);
      return false;
    }
  }
  return true;
};
const handleEditOrg = (id) => {
  const foundOrg = orgs.find(org => org._id === id);
  if (!foundOrg) {
    alert("Org not found");
    return;
  }
  setSelectedOrg(foundOrg);
  setIsModalOpen(true);
  setIsEditMode(true);
};


const handleAddNewOrg = (e) => {
    e.preventDefault();
    setSelectedOrg(null);
    setIsEditMode(false); // Switch to Add mode
    setIsModalOpen(true);
    
  }

const handleClose = async () => {
  await getOrgs();  // Wait for fresh data
  setIsModalOpen(false);
  setSelectedOrg(null);
  setIsEditMode(false);
   setNewOrg({ status: "active" });  // reset newOrg
};

  return (
          <div>
    {isModalOpen ? (
      <div>
           <div className='tableheaderActions'>
      
           <button id="cnew" type="button" className='btn btn-outline-primary' aria-label='Add New'
           onClick={handleClose}
           > Close</button>
         </div>
     
         <div className='branch-main  '>
            <div className='form-sections  '>
                <h4>
                    {
                        isEditMode ?
                            'Edit Org' :
                            'Add New Org'
                    }
                </h4>
                <form onSubmit=
                    {
                        isEditMode ?
                            (e) =>
                                handleUpdate(e) : handleAdd}>
                            
                            <div className='ele'>
                            <label>Org: </label>
                                        <input type="text"
                                    value={
                                        isEditMode ?
                                            selectedOrg.name :
                                            newOrg.name
                                    }
                                    onChange={
                                        (e) =>
                                            isEditMode
                                            ? setSelectedOrg(
                                                {
                                                    ...selectedOrg,
                                                    name: e.target.value
                                                }) :
                                            setNewOrg(
                                                {
                                                    ...newOrg,
                                                    name: e.target.value
                                                }
                                            )} 
                                             disabled={isEditMode} // 🔒 disables input in edit mode           
                                            />
                    <br />
                    <label>Org Acronym: </label>
                                <input type="text"
                                    value={
                                        isEditMode ?
                                            selectedOrg.acr :
                                            newOrg.acr
                                    }
                                    onChange={
                                        (e) =>
                                            isEditMode
                                            ? setSelectedOrg(
                                                {
                                                    ...selectedOrg,
                                                    acr: e.target.value
                                                }) :
                                            setNewOrg(
                                                {
                                                    ...newOrg,
                                                    acr: e.target.value
                                                }
                                            )}
                                        disabled={isEditMode} // 🔒 disables input in edit mode    
                                            />
                            <br />
                            </div>
                            <div className='ele'>
                                <label>Org Address: </label>
                                <input type="text"
                                    value={
                                        isEditMode ?
                                        selectedOrg?.address :
                                            newOrg?.address
                                    }
                                    onChange={
                                        (e) =>
                                            isEditMode
                                            ? setSelectedOrg(
                                                {
                                                    ...selectedOrg,
                                                    address: e.target.value
                                                }) :
                                            setNewOrg(
                                                {
                                                    ...newOrg,
                                                    address: e.target.value
                                                }
                                            )} />
                            <br />
                            <label>Status: </label>
                              <select
                                      value=
                                      {
                                          isEditMode ?
                                          selectedOrg.status : "inactive"
                                      }
                                      onChange={
                                          (e) =>
                                              isEditMode ?
                                                 setSelectedOrg(
                                                      {
                                                          ...selectedOrg,
                                                          status: e.target.value
                                                      }) :
                                                  setNewOrg(
                                                      {
                                                          ...newOrg,
                                                          status: e.target.value
                                                      }
                                                  )}                                                                    
                                        >
                                          <option value="active">Active</option>
                                          <option value="inactive">Inactive</option>
                                        </select>
                                  <br />
                                  </div>
                         <div className='ele'>
                            <label>Org Phone 1: </label>
                                <input type="text"
                                    value={
                                        isEditMode ?
                                            selectedOrg?.phone1 :
                                            newOrg?.phone1
                                    }
                                    placeholder="Enter 10-digit number"
                                    maxLength={10}
                                    onChange={
                                        (e) =>
                                            isEditMode
                                            ? setSelectedOrg(
                                                {
                                                    ...selectedOrg,
                                                    phone1: e.target.value
                                                }) :
                                            setNewOrg(
                                                {
                                                    ...newOrg,
                                                    phone1: e.target.value
                                                }
                                            )} />
                            <br />
                            <br />
                            <label>Org Phone 2: </label>
                                <input type="text"
                                    value={
                                        isEditMode ?
                                            selectedOrg?.phone2 :
                                            newOrg?.phone2
                                    }
                                    placeholder="Enter 10-digit number"
                                    maxLength={10}
                                    onChange={
                                        (e) =>
                                            isEditMode
                                            ? setSelectedOrg(
                                                {
                                                    ...selectedOrg,
                                                    phone2: e.target.value
                                                }) :
                                            setNewOrg(
                                                {
                                                    ...newOrg,
                                                    phone2: e.target.value
                                                }
                                            )} />
                            <br />
                            </div>
                            <div className='ele'>
                            <label>Org Email 1: </label>
                                <input type="text"
                                    value={
                                        isEditMode ?
                                            selectedOrg?.email1 :
                                            newOrg?.email1
                                    }
                                    onChange={
                                        (e) =>
                                            isEditMode
                                            ? setSelectedOrg(
                                                {
                                                    ...selectedOrg,
                                                    email1: e.target.value
                                                }) :
                                            setNewOrg(
                                                {
                                                    ...newOrg,
                                                    email1: e.target.value
                                                }
                                            )} />
                            <br />
                            <br />
                            <label>Org email 2: </label>
                                <input type="text"
                                    value={
                                        isEditMode ?
                                            selectedOrg?.email2 :
                                            newOrg?.email2
                                    }
                                    onChange={
                                        (e) =>
                                            isEditMode
                                            ? setSelectedOrg(
                                                {
                                                    ...selectedOrg,
                                                    email2: e.target.value
                                                }) :
                                            setNewOrg(
                                                {
                                                    ...newOrg,
                                                    email2: e.target.value
                                                }
                                            )} />
                            <br />

                            </div>
                            <div className='ele'>
                            <label>Org UPI-ID: </label>
                                <input type="text"
                                    value={
                                        isEditMode ?
                                            selectedOrg?.upid :
                                            newOrg?.upid
                                    }
                                    onChange={
                                        (e) =>
                                            isEditMode
                                            ? setSelectedOrg(
                                                {
                                                    ...selectedOrg,
                                                    upid: e.target.value
                                                }) :
                                            setNewOrg(
                                                {
                                                    ...newOrg,
                                                    upid: e.target.value
                                                }
                                            )} />

                            <br />
                            <label>GSTIN: </label>
                                <input type="text"
                                    value={
                                        isEditMode ?
                                            selectedOrg?.gstin :
                                            newOrg?.gstin
                                    }
                                    onChange={
                                        (e) =>
                                            isEditMode
                                            ? setSelectedOrg(
                                                {
                                                    ...selectedOrg,
                                                    gstin: e.target.value
                                                }) :
                                            setNewOrg(
                                                {
                                                    ...newOrg,
                                                    gstin: e.target.value
                                                }
                                            )} />
                    <button type="submit">
                        {
                            isEditMode ?
                                'Update Org' :
                                'Add Org'
                        }
                    </button>
                    </div>
                </form>
            </div>
        </div>

        </div>) 
      : 
      ( 
      <div> 
      <div className='tableheaderActions'>
      
      <button id="cnew" type="button" className='btn btn-outline-primary' aria-label='Add New'
        onClick={handleAddNewOrg}
      > Add New Org</button>

    </div>
       <h4> Orgs </h4>
       { orgs && orgs.length > 0 && (
        
                    <CustomDataTable
                      columns={ocolumns}
                      data={orgs}
                      selectableRows={false}
                      paginationPerPage={100}
                    />

       )}
</div>

)}
</div>
  );
}
export default Orgs;